const reasons = [
  {
    icon: "ri-book-open-line",
    title: "Built on published WHS™ principles",
    body: "Calculations are based on the published World Handicap System™ recommendations.",
  },
  {
    icon: "ri-global-line",
    title: "Works with rated golf courses worldwide",
    body: "Anywhere with a Course Rating and Slope Rating — from championship venues to your local club.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Designed for accuracy",
    body: "Built for clubs and societies that can't afford to get strokes wrong on competition day.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Fast & mobile-friendly",
    body: "Check shots from the first tee. No app install, no chart on paper, no faffing about.",
  },
  {
    icon: "ri-heart-line",
    title: "Created by golfers, for golfers",
    body: "Made by a small team who play, run competitions and organise trips themselves.",
  },
  {
    icon: "ri-time-line",
    title: "Regularly updated",
    body: "Course rules and allowance percentages updated to reflect the latest WHS™ guidance.",
  },
];

const trustBadges = [
  "20+ golf formats supported",
  "Works with mixed tees & genders",
  "Official Course & Slope Ratings",
  "Used by golf societies & clubs",
];

export default function Trust() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.18em] text-secondary-700 font-semibold">Why HANDICALC®</span>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight">
            <a href="#trust">Why golfers trust HANDICALC®</a>
          </h2>
          <p className="mt-4 text-foreground-700 text-base md:text-lg leading-relaxed">
            Whether you're organising a club event, planning a tour, or just playing a weekend match,
            HANDICALC® ensures everyone receives the correct allowances every time.
          </p>
        </div>

        {/* Trust badges */}
        <div className="mt-8 flex flex-wrap gap-3">
          {trustBadges.map((badge) => (
            <span
              key={badge}
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-accent-100/80 text-accent-900 text-sm font-medium border border-accent-200/60 whitespace-nowrap"
            >
              <i className="ri-checkbox-circle-fill text-accent-600"></i>
              {badge}
            </span>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <article
              key={r.title}
              className="group rounded-xl bg-background-100 hover:bg-background-200/70 border border-background-200 p-6 md:p-7 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-800 group-hover:bg-primary-600 group-hover:text-background-50 transition-colors">
                <i className={`${r.icon} text-xl`}></i>
              </span>
              <h4 className="mt-5 font-heading font-semibold text-foreground-950 text-lg">
                <a href="#trust" className="cursor-pointer">{r.title}</a>
              </h4>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{r.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}